/**
 * AutoCount - Create Shipment Page
 */

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Autocomplete from "@mui/material/Autocomplete";

import { useNavigate } from "react-router-dom";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

const suppliers = ["AutoZone Distribution", "NAPA Auto Parts", "O'Reilly Auto Parts", "RockAuto", "Advance Auto Parts"];
const warehouses = ["Main Warehouse - Detroit", "West Coast - Los Angeles", "East Coast - Newark"];

function ShipmentsCreate(): JSX.Element {
  const navigate = useNavigate();
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Create New Shipment
                </MDTypography>
              </MDBox>
              <MDBox p={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      options={suppliers}
                      renderInput={(params) => <MDInput {...params} label="Supplier *" />}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      options={warehouses}
                      renderInput={(params) => <MDInput {...params} label="Destination Warehouse *" />}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput label="PO Number" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput label="Tracking Number" fullWidth />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <MDInput label="Expected Date" type="date" fullWidth InputLabelProps={{ shrink: true }} />
                  </Grid>
                  <Grid item xs={12}>
                    <MDInput label="Notes" fullWidth multiline rows={2} />
                  </Grid>
                </Grid>

                <MDBox mt={4}>
                  <MDTypography variant="h6" mb={2}>Shipment Items</MDTypography>
                  <MDTypography variant="body2" color="text">
                    Add parts to this shipment by searching or scanning.
                  </MDTypography>
                  <MDBox mt={2}>
                    <MDButton variant="outlined" color="info">Add Items</MDButton>
                  </MDBox>
                </MDBox>

                <MDBox mt={4} display="flex" justifyContent="flex-end" gap={2}>
                  <MDButton variant="outlined" color="secondary" onClick={() => navigate("/shipments")}>Cancel</MDButton>
                  <MDButton variant="gradient" color="info" onClick={() => navigate("/shipments")}>Create Shipment</MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ShipmentsCreate;
